export default __webpack_public_path__ + "static/media/fig-02-weak-zone-log.35d142c5.png";